export const CSV_SEPARATOR = ', ';
export const CSV_SEPARATOR_DELIVERY = ' | ';
